import { TranslateFunc } from 'src/components/translate';
import { Category } from 'src/types';

export const getSizeTitle = (t: TranslateFunc) => {
  return `${t('product', 'label.size')}`;
};

export const getFractalRepresentation = (numericString: string) => {
  const integerValue = parseInt(numericString, 10);
  const decimalValue = parseFloat(numericString) % 1;
  if (isNaN(integerValue) || isNaN(decimalValue)) {
    return numericString;
  }
  if (decimalValue > 0.4 && decimalValue < 0.6) {
    return `${integerValue} ½`;
  }
  if (decimalValue > 0.25 && decimalValue < 0.4) {
    return `${integerValue} ⅓`;
  }
  if (decimalValue > 0.6 && decimalValue < 0.75) {
    return `${integerValue} ⅔`;
  }
  return numericString;
};

const CATEGORY_SHOES = '1490';
const CATEGORY_CLOTHES = '1618';

export const isSizeVariantsEnabledForCategory = (
  showExperimentForClothesMobile: boolean,
  isMobile: boolean,
  category?: Category | null
) => {
  // Clothes sizes enabled for desktop
  // and on mobile as experiment
  const ALLOWED_CATEGORIES =
    showExperimentForClothesMobile || !isMobile
      ? [CATEGORY_SHOES, CATEGORY_CLOTHES]
      : [CATEGORY_SHOES];

  const isInAllowedCategories = Boolean(
    category?.path?.length &&
      category?.path?.length >= 1 &&
      ALLOWED_CATEGORIES.includes(category.path[1]?.id as string)
  );

  return isInAllowedCategories;
};
